import React from 'react';
import { List, ListItemButton, ListItemText, Collapse, ListItem } from '@mui/material';
import { ChevronLeft, ChevronRight, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Link as RouterLink} from 'react-router-dom';

function LegalMenu({ isLegalOpen, onLegalClick, toggleMenu }) {
  return (
    <React.Fragment>
      <ListItemButton onClick={onLegalClick}>
        <ListItemText primary="Legal" />
        {isLegalOpen ? <ExpandMore /> : <ChevronRight />}
      </ListItemButton><Collapse in={isLegalOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{ pt: 0, pb: 0 }}>
          <ListItemButton component={RouterLink} to="/legal/privacy" sx={{ pl: 4 }} onClick={toggleMenu}>
            <ListItemText primary="Privacy" />
          </ListItemButton>
          <ListItemButton component={RouterLink} to="/legal/terms" sx={{ pl: 4 }} onClick={toggleMenu}>
            <ListItemText primary="Terms" />
          </ListItemButton>
          <ListItemButton component={RouterLink} to="/legal/cookies" sx={{ pl: 4 }} onClick={toggleMenu}>
            <ListItemText primary="Cookies" />
          </ListItemButton>
        </List>
      </Collapse>
    </React.Fragment>
  );
}

export default LegalMenu;
